import React, {Component} from "react";
import './Header.css'
import {Link, animateScroll as scroll} from "react-scroll";

class Header extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <section className="Header" id={"section1"} >
                <nav className="nav">
                    <ul >
                        <li className="nav-item" >
                            <Link activeClass="active" onClick={this.props.clicked} to="section3" spy={true} smooth={true} offset={0} duration={500}>Skills</Link>
                        </li>
                        <li className="nav-item">
                            <Link activeClass="active" onClick={this.props.clicked} to="section4" spy={true} smooth={true} offset={0} duration={500}>Projects</Link>
                        </li>
                        <li className="nav-item">
                            <Link activeClass="active" onClick={this.props.clicked} to="section5" spy={true} smooth={true} offset={0} duration={500}>Contact</Link>
                        </li>
                    </ul>
                </nav>
            </section>
        )
    }


}


export default Header
